module.exports = {
  names: {
    '1': '°C',
    '2': '°F',
    '3': '%',
    '4': 'lx',
    '5': 'W',
    '6': 'V',
    '7': 'mA',
    '8': '%',
    '9': 'kWh',
    '10': 'ppm',
    '11': 'ppbv',
    '12': 'UVI'
  },
  factors: {
    '1': 10,
    '2': 10,
    '3': 1,
    '4': 1,
    '5': 10,
    '6': 100,
    '7': 1,
    '8': 100,
    '9': 100,
    '10': 1,
    '11': 1,
    '12': 1
  },
  minimums: {
    '2': 32
  },
  maximums: {
    '1': 45,
    '2': 120,
    '3': 100,
    '8': 100
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/DeviceUnits.js
// module id = 8Iw+
// module chunks = 0